var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { staticClass: "liveinfo-form", attrs: { "no-body": "" } }, [
        _c(
          "div",
          { staticClass: "m-2" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start mb-1 mb-md-0",
                    attrs: { cols: "12", md: "10" },
                  },
                  [
                    _c("v-select", {
                      staticClass: "el-def",
                      attrs: {
                        options: _vm.codes.contracts,
                        placeholder: "계약명",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                      model: {
                        value: _vm.query.contractId,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "contractId", $$v)
                        },
                        expression: "query.contractId",
                      },
                    }),
                    _c("v-select", {
                      staticClass: "el-def",
                      attrs: {
                        options: _vm.codes.contentType,
                        placeholder: "구분",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                      model: {
                        value: _vm.query.contentType,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "contentType", $$v)
                        },
                        expression: "query.contentType",
                      },
                    }),
                    _c("v-select", {
                      staticClass: "el-def",
                      attrs: {
                        options: _vm.codes.postStatusType,
                        placeholder: "게시상태",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                      model: {
                        value: _vm.query.postStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "postStatus", $$v)
                        },
                        expression: "query.postStatus",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-row",
              { staticClass: "mt-1" },
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start mb-1 mb-md-0",
                    attrs: { cols: "12", md: "10" },
                  },
                  [
                    _c("b-form-datepicker", {
                      staticClass: "el-def",
                      attrs: { placeholder: "게시기간(Fr)" },
                      model: {
                        value: _vm.query.startDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "startDate", $$v)
                        },
                        expression: "query.startDate",
                      },
                    }),
                    _c("b-form-datepicker", {
                      staticClass: "el-def",
                      attrs: { placeholder: "게시기간(To)" },
                      model: {
                        value: _vm.query.endDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "endDate", $$v)
                        },
                        expression: "query.endDate",
                      },
                    }),
                    _c("b-form-input", {
                      staticClass: "el-def",
                      staticStyle: { width: "480px" },
                      attrs: { placeholder: "제목" },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.refetchData()
                        },
                      },
                      model: {
                        value: _vm.query.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "title", $$v)
                        },
                        expression: "query.title",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-end",
                    attrs: { cols: "12", md: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-search",
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.refetchData()
                          },
                        },
                      },
                      [_vm._v(" 조회 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "div",
            { staticClass: "m-2" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c("h5", { staticClass: "mb-0 ml-50" }, [
                        _vm._v(
                          " 게시글 리스트 [" +
                            _vm._s(_vm.totalRecords) +
                            "] 건 "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-table", {
            ref: "refInfoTable",
            staticClass: "position-relative",
            attrs: {
              "primary-key": "id",
              items: _vm.fetchInfos,
              fields: _vm.tableColumns,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.isSortDesc,
              responsive: "",
              "sticky-header": "",
              selectable: "",
              "select-mode": "single",
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.isSortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.isSortDesc = $event
              },
              "row-selected": _vm.onRowSelectedInfo,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(startDate)",
                fn: function (data) {
                  return [
                    _c("span", { staticClass: "text-nowrap" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("$dateFormatter")(data.value, "YYYY-MM-DD")
                          ) +
                          " ~ " +
                          _vm._s(
                            _vm._f("$dateFormatter")(
                              data.item.endDate,
                              "YYYY-MM-DD"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.totalRecords,
              limit: "10",
              "per-page": "10",
              align: "center",
            },
            model: {
              value: _vm.currPage,
              callback: function ($$v) {
                _vm.currPage = $$v
              },
              expression: "currPage",
            },
          }),
        ],
        1
      ),
      _c("b-card", { attrs: { "no-body": "" } }, [
        _c(
          "div",
          { staticClass: "m-2" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start",
                    attrs: { cols: "12", md: "6" },
                  },
                  [
                    _c("feather-icon", {
                      attrs: { icon: "EditIcon", size: "19" },
                    }),
                    _c("h4", { staticClass: "mb-0 ml-50" }, [_vm._v(" 상세 ")]),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-end",
                    attrs: { cols: "12", md: "6" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-primary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.resetInfoData()
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "PlusSquareIcon" },
                        }),
                        _c("span", [_vm._v("신규 등록")]),
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.saveInfo()
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "SaveIcon" },
                        }),
                        _c("span", [_vm._v("저장")]),
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: { variant: "outline-secondary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.removeInfo()
                          },
                        },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "Trash2Icon" },
                        }),
                        _c("span", [_vm._v("삭제")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-row",
              { staticClass: "mt-1" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "구분", "label-for": "contentType" } },
                      [
                        _c("b-form-radio-group", {
                          attrs: {
                            id: "contentType",
                            options: _vm.codes.contentType,
                            "value-field": "code",
                            "text-field": "label",
                          },
                          model: {
                            value: _vm.infoData.contentType,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "contentType", $$v)
                            },
                            expression: "infoData.contentType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.infoData.contentType === 1
              ? [
                  _c(
                    "validation-observer",
                    { ref: "materialRules" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "9" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "제목",
                                    "label-for": "title",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { name: "제목", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "title",
                                                  placeholder:
                                                    "제목을 입력하세요. (최대 50자)",
                                                  maxlength: "50",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value: _vm.infoData.title,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "title",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "infoData.title",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      485183232
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "9" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "서브 텍스트",
                                    "label-for": "sub-text",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "서브 텍스트",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "sub-text",
                                                  placeholder:
                                                    "서브 텍스트를 입력하세요. (최대 100자)",
                                                  maxlength: "100",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value: _vm.infoData.subText,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "subText",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.subText",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      332260769
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "9" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "게시글 링크",
                                    "label-for": "linkUrl",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "게시글 링크",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "linkUrl",
                                                  placeholder:
                                                    "게시글 링크를 입력하세요.",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value: _vm.infoData.linkUrl,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "linkUrl",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.linkUrl",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1564507043
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "계약명",
                                    "label-for": "contractName",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "계약명",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("v-select", {
                                                attrs: {
                                                  options:
                                                    _vm.codes.validContracts,
                                                  placeholder: "선택",
                                                  reduce: function (option) {
                                                    return option.code
                                                  },
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.infoData.deskContractId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "deskContractId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.deskContractId",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      170936190
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "8", md: "3" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "관련 질환",
                                    "label-for": "deskDiseaseId",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "관련 질환",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("v-select", {
                                                attrs: {
                                                  options: _vm.codes.diseases,
                                                  placeholder: "선택",
                                                  reduce: function (option) {
                                                    return option.code
                                                  },
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.infoData.deskDiseaseId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "deskDiseaseId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.deskDiseaseId",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1680267336
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "4", md: "2" } },
                            [
                              _c(
                                "b-button",
                                {
                                  ref: "diseaseShowButton",
                                  staticClass: "mt-0 mt-md-2",
                                  attrs: { variant: "outline-primary" },
                                  on: { click: _vm.onClickDiseaseShowButton },
                                },
                                [_c("span", [_vm._v("항목 설정")])]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c("label", [_vm._v("게시 기간")]),
                          ]),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "게시기간(Fr)",
                                  rules: {
                                    required: true,
                                    before: _vm.infoData.endDate,
                                    dateBetween: [
                                      _vm.contractFr,
                                      _vm.contractTo,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              placeholder: "게시기간(Fr)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.infoData.startDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.infoData,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression: "infoData.startDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "required"
                                                    )
                                                      ? "[게시 기간]는(은) 필수 입력입니다."
                                                      : failedRules.hasOwnProperty(
                                                          "before"
                                                        )
                                                      ? "게시기간(To) 이전이어야 합니다."
                                                      : failedRules.hasOwnProperty(
                                                          "dateBetween"
                                                        )
                                                      ? "[게시 기간]은 계약기간(" +
                                                        _vm.contractFrDisp +
                                                        " ~ " +
                                                        _vm.contractToDisp +
                                                        ") 내로 설정해야 합니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  464617681
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "게시기간(To)",
                                  rules: {
                                    required: true,
                                    after: _vm.infoData.startDate,
                                    dateBetween: [
                                      _vm.contractFr,
                                      _vm.contractTo,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              placeholder: "게시기간(To)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.infoData.endDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.infoData,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression: "infoData.endDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "required"
                                                    )
                                                      ? "[게시 기간]는(은) 필수 입력입니다."
                                                      : failedRules.hasOwnProperty(
                                                          "after"
                                                        )
                                                      ? "게시기간(Fr) 이후여야 합니다."
                                                      : failedRules.hasOwnProperty(
                                                          "dateBetween"
                                                        )
                                                      ? "[게시 기간]은 계약기간(" +
                                                        _vm.contractFrDisp +
                                                        " ~ " +
                                                        _vm.contractToDisp +
                                                        ") 내로 설정해야 합니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3182512431
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "초기 노출 상태",
                                    "label-for": "isShow",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "초기 노출 상태",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-radio-group", {
                                                attrs: {
                                                  id: "isShow",
                                                  options: _vm.codes.isShowType,
                                                  disabled: _vm.infoData.isLive,
                                                  "value-field": "code",
                                                  "text-field": "label",
                                                },
                                                model: {
                                                  value: _vm.infoData.isShow,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "isShow",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "infoData.isShow",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1403221949
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm.infoData.contentType === 2
              ? [
                  _c(
                    "validation-observer",
                    { ref: "webinarRules" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "9" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "제목",
                                    "label-for": "title",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { name: "제목", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "title",
                                                  placeholder:
                                                    "제목을 입력하세요. (최대 50자)",
                                                  maxlength: "50",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value: _vm.infoData.title,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "title",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "infoData.title",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      485183232
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "9" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "연자",
                                    "label-for": "speaker",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { name: "연자", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "speaker",
                                                  placeholder:
                                                    "연자를 입력하세요. (최대 50자)",
                                                  maxlength: "50",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value: _vm.infoData.subText,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "subText",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.subText",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1758255983
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "진행 일자",
                                    "label-for": "watch-date",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "진행 일자",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-datepicker", {
                                                attrs: {
                                                  id: "watch-date",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.infoData.watchStartDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "watchStartDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.watchStartDate",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      712351972
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "시작 시간",
                                    "label-for": "start-time",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "시작 시간",
                                      rules: {
                                        required: true,
                                        before: _vm.infoData.watchEndTime,
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("v-date-picker", {
                                                attrs: {
                                                  id: "start-time",
                                                  type: "time",
                                                  format: "HH:mm",
                                                  "value-type": "format",
                                                  placeholder: "HH:mm",
                                                },
                                                model: {
                                                  value:
                                                    _vm.infoData.watchStartTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "watchStartTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.watchStartTime",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1940876906
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label:
                                      "종료 시간 (※ 선택 입력 항목입니다.)",
                                    "label-for": "end-time",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "종료 시간",
                                      rules: {
                                        required: false,
                                        after: _vm.infoData.watchStartTime,
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("v-date-picker", {
                                                attrs: {
                                                  id: "end-time",
                                                  type: "time",
                                                  format: "HH:mm",
                                                  "value-type": "format",
                                                  placeholder: "HH:mm",
                                                },
                                                model: {
                                                  value:
                                                    _vm.infoData.watchEndTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "watchEndTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.watchEndTime",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2256686698
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "9" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "게시글 링크",
                                    "label-for": "linkUrl",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "게시글 링크",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "linkUrl",
                                                  placeholder:
                                                    "게시글 링크를 입력하세요.",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value: _vm.infoData.linkUrl,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "linkUrl",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.linkUrl",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1564507043
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "9" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "시청 링크",
                                    "label-for": "watchLinkUrl",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "시청 링크",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "watchLinkUrl",
                                                  placeholder:
                                                    "시청 링크를 입력하세요.",
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.infoData.watchLinkUrl,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "watchLinkUrl",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.watchLinkUrl",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2602248194
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "계약명",
                                    "label-for": "contractName",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "계약명",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("v-select", {
                                                attrs: {
                                                  options: _vm.codes.contracts,
                                                  placeholder: "선택",
                                                  reduce: function (option) {
                                                    return option.code
                                                  },
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.infoData.deskContractId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "deskContractId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.deskContractId",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2500302056
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "8", md: "3" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "관련 질환",
                                    "label-for": "deskDiseaseId",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "관련 질환",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("v-select", {
                                                attrs: {
                                                  options: _vm.codes.diseases,
                                                  placeholder: "선택",
                                                  reduce: function (option) {
                                                    return option.code
                                                  },
                                                  state:
                                                    errors.length > 0
                                                      ? false
                                                      : null,
                                                },
                                                model: {
                                                  value:
                                                    _vm.infoData.deskDiseaseId,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "deskDiseaseId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "infoData.deskDiseaseId",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1680267336
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "4", md: "2" } },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-0 mt-md-2",
                                  attrs: { variant: "outline-primary" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.showDeskDiseaseManage = true
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("항목 설정")])]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c("label", [_vm._v("게시 기간")]),
                          ]),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "게시기간(Fr)",
                                  rules: {
                                    required: true,
                                    before: _vm.infoData.endDate,
                                    dateBetween: [
                                      _vm.contractFr,
                                      _vm.contractTo,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              placeholder: "게시기간(Fr)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.infoData.startDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.infoData,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression: "infoData.startDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "required"
                                                    )
                                                      ? "[게시 기간]는(은) 필수 입력입니다."
                                                      : failedRules.hasOwnProperty(
                                                          "before"
                                                        )
                                                      ? "게시기간(To) 이전이어야 합니다."
                                                      : failedRules.hasOwnProperty(
                                                          "dateBetween"
                                                        )
                                                      ? "[게시 기간]은 계약기간(" +
                                                        _vm.contractFrDisp +
                                                        " ~ " +
                                                        _vm.contractToDisp +
                                                        ") 내로 설정해야 합니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  464617681
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "게시기간(To)",
                                  rules: {
                                    required: true,
                                    after: _vm.infoData.startDate,
                                    dateBetween: [
                                      _vm.contractFr,
                                      _vm.contractTo,
                                    ],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        var failedRules = ref.failedRules
                                        return [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              placeholder: "게시기간(To)",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: _vm.infoData.endDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.infoData,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression: "infoData.endDate",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    failedRules.hasOwnProperty(
                                                      "required"
                                                    )
                                                      ? "[게시 기간]는(은) 필수 입력입니다."
                                                      : failedRules.hasOwnProperty(
                                                          "after"
                                                        )
                                                      ? "게시기간(Fr) 이후여야 합니다."
                                                      : failedRules.hasOwnProperty(
                                                          "dateBetween"
                                                        )
                                                      ? "[게시 기간]은 계약기간(" +
                                                        _vm.contractFrDisp +
                                                        " ~ " +
                                                        _vm.contractToDisp +
                                                        ") 내로 설정해야 합니다."
                                                      : errors[0]
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3182512431
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "초기 노출 상태",
                                    "label-for": "isShow",
                                  },
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "초기 노출 상태",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("b-form-radio-group", {
                                                attrs: {
                                                  id: "isShow",
                                                  options: _vm.codes.isShowType,
                                                  disabled: _vm.infoData.isLive,
                                                  "value-field": "code",
                                                  "text-field": "label",
                                                },
                                                model: {
                                                  value: _vm.infoData.isShow,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.infoData,
                                                      "isShow",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "infoData.isShow",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1403221949
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "강의 취소 여부",
                                    "label-for": "is-cancel",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      model: {
                                        value: _vm.infoData.isCancel,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.infoData,
                                            "isCancel",
                                            $$v
                                          )
                                        },
                                        expression: "infoData.isCancel",
                                      },
                                    },
                                    [_vm._v(" 취소 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm.infoData.contentType === 2
        ? _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { md: "6" },
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "BellIcon", size: "19" },
                      }),
                      _c(
                        "h4",
                        {
                          staticClass: "mb-0 ml-50",
                          staticStyle: { "min-width": "120px" },
                        },
                        [_vm._v(" 시청 알림 팝업 ")]
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "custom-control-info",
                          attrs: { switch: "", inline: "" },
                          on: { change: _vm.initNpu },
                          model: {
                            value: _vm.infoData.isNpuUse,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "isNpuUse", $$v)
                            },
                            expression: "infoData.isNpuUse",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.infoData.isNpuUse ? "사용" : "사용안함"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "validation-observer",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.infoData.isNpuUse,
                      expression: "infoData.isNpuUse",
                    },
                  ],
                  ref: "npuRules",
                },
                _vm._l(_vm.infoData.npus, function (m, idx) {
                  return _c(
                    "b-row",
                    {
                      key: "npu" + idx,
                      class: { "mt-1": idx === 0 },
                      attrs: { id: "npu" + idx },
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림 시간",
                                "label-for": "npuBeforeMinute",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  vid: "npuBeforeMinute" + idx,
                                  name: "알림 시간",
                                  rules: {
                                    required: _vm.required,
                                    npuDupRule: _vm.npuDupRule,
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("v-select", {
                                            attrs: {
                                              id: "npuBeforeMinute",
                                              options:
                                                _vm.codes.npuBeforeMinutes,
                                              placeholder: "선택",
                                              reduce: function (option) {
                                                return option.code
                                              },
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            on: {
                                              input: _vm.changeNpuBeforeMinute,
                                            },
                                            model: {
                                              value: m.noticeBeforeMinute,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  m,
                                                  "noticeBeforeMinute",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "m.noticeBeforeMinute",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "mt-1",
                          staticStyle: {
                            flex: "none",
                            width: "175px",
                            "padding-left": "0",
                          },
                          attrs: { md: "2" },
                        },
                        [
                          _c("b-form-input", {
                            staticStyle: { width: "175px" },
                            attrs: {
                              type: "search",
                              size: "lg",
                              plaintext: "",
                              value: _vm.dispNpuTime(m.noticeBeforeMinute),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림 유지 시간",
                                "label-for": "npuDuration",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  vid: "npuDuration" + idx,
                                  name: "알림 유지 시간",
                                  rules: "required",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("v-select", {
                                            attrs: {
                                              id: "npuDuration",
                                              options: _vm.codes.durations,
                                              placeholder: "선택",
                                              reduce: function (option) {
                                                return option.code
                                              },
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                            model: {
                                              value: m.duration,
                                              callback: function ($$v) {
                                                _vm.$set(m, "duration", $$v)
                                              },
                                              expression: "m.duration",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-start",
                          staticStyle: { "margin-top": "7px" },
                          attrs: { md: "2" },
                        },
                        [
                          idx !== 0
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    variant: "outline-danger",
                                    size: "sm",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.infoData.npus.splice(idx, 1)
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-25",
                                    attrs: { icon: "XIcon" },
                                  }),
                                  _c("span", [_vm._v("삭제")]),
                                ],
                                1
                              )
                            : _vm._e(),
                          idx === _vm.infoData.npus.length - 1
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "outline-primary",
                                    size: "sm",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.infoData.npus.push({
                                        noticeBeforeMinute: null,
                                        duration: 10,
                                      })
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-25",
                                    attrs: { icon: "PlusIcon" },
                                  }),
                                  _c("span", [_vm._v("추가")]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.infoData.contentType === 2
        ? _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { md: "6" },
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "ClockIcon", size: "19" },
                      }),
                      _c(
                        "h4",
                        {
                          staticClass: "mb-0 ml-50",
                          staticStyle: { "min-width": "120px" },
                        },
                        [_vm._v(" 스케줄 팝업 ")]
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "custom-control-info",
                          attrs: { switch: "", inline: "" },
                          on: { change: _vm.initSpu },
                          model: {
                            value: _vm.infoData.isSpuUse,
                            callback: function ($$v) {
                              _vm.$set(_vm.infoData, "isSpuUse", $$v)
                            },
                            expression: "infoData.isSpuUse",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.infoData.isSpuUse ? "사용" : "사용안함"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "validation-observer",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.infoData.isSpuUse,
                      expression: "infoData.isSpuUse",
                    },
                  ],
                  ref: "spuRules",
                },
                [
                  _vm._l(_vm.infoData.spus, function (m, idx) {
                    return _c(
                      "b-row",
                      {
                        key: "spu" + idx,
                        class: { "mt-1": idx === 0 },
                        attrs: { id: "spu" + idx },
                      },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "2" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "알림 기간(Fr)",
                                  "label-for": "spuStartDate",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    vid: "spuStartDate" + idx,
                                    name: "알림 기간(Fr)",
                                    rules: {
                                      required: _vm.required,
                                      before: m.endDate,
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          var failedRules = ref.failedRules
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                placeholder: "알림 기간(Fr)",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: m.startDate,
                                                callback: function ($$v) {
                                                  _vm.$set(m, "startDate", $$v)
                                                },
                                                expression: "m.startDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      failedRules.hasOwnProperty(
                                                        "required"
                                                      )
                                                        ? "[알림 기간(Fr)]는(은) 필수 입력입니다."
                                                        : failedRules.hasOwnProperty(
                                                            "before"
                                                          )
                                                        ? "알림 기간(To) 이전이어야 합니다."
                                                        : errors[0]
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { cols: "12", md: "2" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "알림 기간(To)",
                                  "label-for": "spuEndDate",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    vid: "spuEndDate" + idx,
                                    name: "알림 기간(To)",
                                    rules: {
                                      required: _vm.required,
                                      after: m.startDate,
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          var failedRules = ref.failedRules
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                placeholder: "알림 기간(To)",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: m.endDate,
                                                callback: function ($$v) {
                                                  _vm.$set(m, "endDate", $$v)
                                                },
                                                expression: "m.endDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      failedRules.hasOwnProperty(
                                                        "required"
                                                      )
                                                        ? "[알림 기간(To)]는(은) 필수 입력입니다."
                                                        : failedRules.hasOwnProperty(
                                                            "before"
                                                          )
                                                        ? "알림 기간(Fr) 이후여야 합니다."
                                                        : errors[0]
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "알림 시간",
                                  "label-for": "noticeTime",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "알림 시간",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("v-date-picker", {
                                              attrs: {
                                                type: "time",
                                                format: "HH:mm",
                                                "value-type": "format",
                                                placeholder: "HH:mm",
                                              },
                                              model: {
                                                value: m.noticeTime,
                                                callback: function ($$v) {
                                                  _vm.$set(m, "noticeTime", $$v)
                                                },
                                                expression: "m.noticeTime",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "2" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "알림 유지 시간",
                                  "label-for": "spuDuration",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    vid: "spuDuration" + idx,
                                    name: "알림 유지 시간",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("v-select", {
                                              attrs: {
                                                options: _vm.codes.durations,
                                                placeholder: "선택",
                                                reduce: function (option) {
                                                  return option.code
                                                },
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: m.duration,
                                                callback: function ($$v) {
                                                  _vm.$set(m, "duration", $$v)
                                                },
                                                expression: "m.duration",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-start",
                            staticStyle: { "margin-top": "7px" },
                            attrs: { md: "2" },
                          },
                          [
                            idx !== 0
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      variant: "outline-danger",
                                      size: "sm",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.infoData.spus.splice(idx, 1)
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-25",
                                      attrs: { icon: "XIcon" },
                                    }),
                                    _c("span", [_vm._v("삭제")]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            idx === _vm.infoData.spus.length - 1
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "outline-primary",
                                      size: "sm",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.infoData.spus.push({
                                          startDate: null,
                                          endDate: null,
                                          noticeTime: null,
                                          duration: 10,
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-25",
                                      attrs: { icon: "PlusIcon" },
                                    }),
                                    _c("span", [_vm._v("추가")]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "b-row",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "9" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "알림창 내용",
                                "label-for": "spuContent",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  name: "알림창 내용",
                                  rules: "required",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("tinymce-editor", {
                                            attrs: { "is-table": true },
                                            model: {
                                              value: _vm.infoData.spuContent,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.infoData,
                                                  "spuContent",
                                                  $$v
                                                )
                                              },
                                              expression: "infoData.spuContent",
                                            },
                                          }),
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3252447450
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _c("desk-disease-manage", {
        attrs: { "show-desk-disease-manage": _vm.showDeskDiseaseManage },
        on: { close: _vm.deskDiseaseManage.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }